<template>
    <confirm-dialog title="채용 상세" maxWidth="400" hideActions>
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <div class="mb-4 mb-lg-8">채용: {{ value.employMsg }}</div>
    </confirm-dialog>
</template>

<script>
import ConfirmDialog from "@/components/dumb/confirm-dialog.vue";
import { initExpoMatching } from "@/assets/variables";
export default {
    components: {
        ConfirmDialog,
    },
    props: {
        value: { type: Object, default: initExpoMatching },
    },
};
</script>

<style>
</style>